import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "../components/Navigation/NavBar";
import { useNavigate } from "react-router-dom";
import { BASE_URL, LOGOUT_PATH, PROFILE_PATH } from "../utility/path";
import { getConfig, getConstant, handleHeader, isDigit } from "../services/functions";
import { spinner } from "../redux/slices/spinnerSlice";
import axios from "axios";
import { showAlert } from "../redux/slices/alertSlice";
import EnterOtp from "./EnterOtp";
import MainContainer from "../components/MainContainer";

const DeleteAccount = ({ }) => {
  const profileData = useSelector(state => state?.profile?.data);
  const authData = useSelector(state => state?.auth?.data);
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const [state, setState] = useState({
    vendor: false,
    otp: "",
    locationPathname: "",
    id: profileData?.id,
    action: "delete_account"
  });

  useEffect(() => {
    handleHeader({ ...getConstant("DELETE_ACCOUNT") }, dispatch);
    if (authData?.nextStep === 1) {
      if (authData?.message) {
        dispatch(showAlert({ message: authData?.message , success: true }));
      }
      navigate(LOGOUT_PATH);
    }

  }, []);

  const handleChangeOtp = (input, value) => {
    if (!isDigit(value)) {
      return;
    }
    setState((prevState) => ({ ...prevState, [input]: value }));
  }

  const previousStep = async () => {
    navigate(PROFILE_PATH);
  }

  return (
    <>
      <NavBar />
      <MainContainer>
        <EnterOtp previousStep={previousStep} handleChangeOtp={handleChangeOtp} state={state} />
      </MainContainer>
    </>
  );
}

export default DeleteAccount;
